import React from "react";

export default {
  title: "OUR PARTNERS"
}
